import gql from "graphql-tag";

const segmentsQuery = gql`
  query marketsSegments($market: ID) {
    sectors(market: $market) {
      edges {
        node {
          id
          name
          nameEn
        }
      }
    }
  }
`;

export default segmentsQuery;